"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __exportStar = this && this.__exportStar || function (m, exports) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaults = exports.ImplementationDetail = exports.WHICSToCommon = exports.WHICS = exports.DefaultsGuHealth = exports.DefaultsING = exports.DefaultsIWHI = exports.DefaultsISHI = exports.DefaultsAPIA = exports.DefaultsSeniors = exports.DefaultsReal = exports.DefaultsPriceline = exports.DefaultsSuncorp = exports.DefaultsAAMI = exports.DefaultsARHI = exports.Defaults = void 0;
const implementation = __importStar(require("./implementationDetail"));
const common = __importStar(require("./common"));
const defaults = __importStar(require("./defaults"));
const defaultsSuncorp = __importStar(require("./defaultsSuncorp"));
const defaultsAAMI = __importStar(require("./defaultsAAMI"));
const defaultsApia = __importStar(require("./defaultsAPIA"));
const defaultsPriceline = __importStar(require("./defaultsPriceline"));
const defaultsReal = __importStar(require("./defaultsReal"));
const defaultsSeniors = __importStar(require("./defaultsSeniors"));
const defaultsIwhi = __importStar(require("./defaultsIWHI"));
const defaultsIshi = __importStar(require("./defaultsISHI"));
const defaultsIng = __importStar(require("./defaultsING"));
const defaultsGuHealth = __importStar(require("./defaultsGuHealth"));
const whics = __importStar(require("./whics"));
const whicsToCommon = __importStar(require("./whicsToCommon"));
__exportStar(require("./common"), exports);
__exportStar(require("./types"), exports);
__exportStar(require("./countries"), exports);
__exportStar(require("./session"), exports);
exports.Defaults = defaults;
exports.DefaultsARHI = defaults; // exported twice for backwards compat
exports.DefaultsAAMI = defaultsAAMI;
exports.DefaultsSuncorp = defaultsSuncorp;
exports.DefaultsPriceline = defaultsPriceline;
exports.DefaultsReal = defaultsReal;
exports.DefaultsSeniors = defaultsSeniors;
exports.DefaultsAPIA = defaultsApia;
exports.DefaultsISHI = defaultsIshi;
exports.DefaultsIWHI = defaultsIwhi;
exports.DefaultsING = defaultsIng;
exports.DefaultsGuHealth = defaultsGuHealth;
exports.WHICS = whics;
exports.WHICSToCommon = whicsToCommon;
exports.ImplementationDetail = implementation;
const getDefaults = fund => {
  // eslint-disable-line
  switch (fund) {
    case common.Funds.ING:
      return defaultsIng;
    case common.Funds.APIA:
      return defaultsApia;
    case common.Funds.PRICELINE:
      return defaultsPriceline;
    case common.Funds.REAL:
      return defaultsReal;
    case common.Funds.SENIORS:
      return defaultsSeniors;
    case common.Funds.GU:
      return defaultsGuHealth;
    case common.Funds.IWHI:
      return defaultsIwhi;
    case common.Funds.ISHI:
      return defaultsIshi;
    case common.Funds.ARHI:
      return defaults;
    default:
      return defaults;
  }
};
exports.getDefaults = getDefaults;